
export const COLORS = {
  // プライマリーカラー
  primary: '#2563eb',
  primaryLight: '#3b82f6',
  primaryDark: '#1e3a8a',
  
  // セカンダリーカラー
  secondary: '#6b7280',
  secondaryLight: '#9ca3af',
  secondaryDark: '#374151',
  
  // アクセントカラー
  accent: '#fbbf24',
  
  // テキストカラー
  textPrimary: '#1f2937',
  textSecondary: '#4b5563',
  textTertiary: '#6b7280',
  
  // 背景カラー
  backgroundPrimary: '#ffffff',
  backgroundSecondary: '#f9fafb',
  backgroundTertiary: '#e5e7eb',
  
  // ニュースカテゴリ
  categoryBackground: '#dbeafe',
  categoryText: '#2563eb',
  
  // リンクカラー
  link: '#2563eb',
  linkHover: '#1e40af',
  
  // 成功・エラー・警告
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
};

// フォントサイズ
export const FONT_SIZES = {
  xs: '12px',
  sm: '14px',
  base: '16px',
  lg: '18px',
  xl: '20px',
  xxl: '24px',
  xxxl: '28px',
  title: '36px',
  hero: '48px',
  display: '56px',
};

// フォントウェイト
export const FONT_WEIGHTS = {
  normal: 'normal',
  medium: '500',
  semibold: '600',
  bold: 'bold',
};

// 余白・サイズ
export const SPACING = {
  xs: '5px',
  sm: '10px',
  base: '15px',
  md: '20px',
  lg: '30px',
  xl: '40px',
  xxl: '60px',
  xxxl: '80px',
};

// ボーダー半径
export const BORDER_RADIUS = {
  sm: '4px',
  base: '6px',
  md: '8px',
  lg: '12px',
  full: '50px',
  circle: '50%',
};

// シャドウ
export const SHADOWS = {
  sm: '0 2px 4px rgba(0,0,0,0.1)',
  base: '0 2px 8px rgba(0,0,0,0.1)',
  md: '0 4px 12px rgba(0,0,0,0.15)',
  lg: '0 8px 20px rgba(0,0,0,0.15)',
  xl: '0 12px 24px rgba(0,0,0,0.2)',
};

// z-index階層
export const Z_INDEX = {
  dropdown: 1000,
  modal: 1010,
  tooltip: 1020,
  navigation: 1030,
  overlay: 1040,
};

// トランジション
export const TRANSITIONS = {
  fast: 'all 0.2s ease',
  base: 'all 0.3s ease',
  slow: 'all 0.5s ease',
  bounce: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
};

// メディアクエリ
export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1200px',
};

export const MEDIA_QUERIES = {
  mobile: `@media (max-width: ${BREAKPOINTS.mobile})`,
  tablet: `@media (max-width: ${BREAKPOINTS.tablet})`,
  desktop: `@media (min-width: ${BREAKPOINTS.desktop})`,
};

// 共通レイアウトスタイル
export const LAYOUT = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: `0 ${SPACING.md}`,
  },
  section: {
    padding: `${SPACING.xxxl} ${SPACING.md}`,
  },
  header: {
    height: '70px',
  },
};

// 共通コンポーネントスタイル
export const COMPONENTS = {
  button: {
    base: {
      padding: `${SPACING.sm} ${SPACING.lg}`,
      fontSize: FONT_SIZES.base,
      fontWeight: FONT_WEIGHTS.bold,
      borderRadius: BORDER_RADIUS.md,
      border: 'none',
      cursor: 'pointer',
      transition: TRANSITIONS.base,
    },
    primary: {
      backgroundColor: COLORS.primary,
      color: COLORS.backgroundPrimary,
    },
    secondary: {
      backgroundColor: 'transparent',
      color: COLORS.primary,
      border: `2px solid ${COLORS.primary}`,
    },
  },
  card: {
    base: {
      backgroundColor: COLORS.backgroundPrimary,
      borderRadius: BORDER_RADIUS.md,
      boxShadow: SHADOWS.base,
      padding: SPACING.xl,
      transition: TRANSITIONS.base,
    },
    hover: {
      boxShadow: SHADOWS.md,
      transform: 'translateY(-2px)',
    },
  },
  input: {
    base: {
      width: '100%',
      padding: SPACING.sm,
      fontSize: FONT_SIZES.base,
      border: `1px solid ${COLORS.backgroundTertiary}`,
      borderRadius: BORDER_RADIUS.sm,
      boxSizing: 'border-box',
    },
    focus: {
      borderColor: COLORS.primary,
      outline: 'none',
      boxShadow: `0 0 0 3px rgba(37, 99, 235, 0.1)`,
    },
  },
};

// モバイル対応の共通CSSクラス文字列
export const MOBILE_STYLES = `
  @media (max-width: ${BREAKPOINTS.mobile}) {
    .mobile-text-sm { font-size: ${FONT_SIZES.sm} !important; }
    .mobile-text-base { font-size: ${FONT_SIZES.base} !important; }
    .mobile-text-lg { font-size: ${FONT_SIZES.lg} !important; }
    .mobile-text-xl { font-size: ${FONT_SIZES.xl} !important; }
    .mobile-text-title { font-size: ${FONT_SIZES.xxxl} !important; }
    .mobile-text-hero { font-size: ${FONT_SIZES.title} !important; }
    
    .mobile-spacing-sm { padding: ${SPACING.sm} !important; }
    .mobile-spacing-base { padding: ${SPACING.base} !important; }
    .mobile-spacing-md { padding: ${SPACING.md} !important; }
    .mobile-spacing-lg { padding: ${SPACING.lg} !important; }
    
    .mobile-section { padding: ${SPACING.xl} ${SPACING.base} !important; }
    .mobile-container { padding: 0 ${SPACING.base} !important; }
    
    .mobile-grid-single { grid-template-columns: 1fr !important; }
    .mobile-grid-double { grid-template-columns: repeat(2, 1fr) !important; }
    
    .mobile-flex-column { flex-direction: column !important; }
    .mobile-flex-start { align-items: flex-start !important; }
    
    .mobile-gap-sm { gap: ${SPACING.sm} !important; }
    .mobile-gap-base { gap: ${SPACING.base} !important; }
    .mobile-gap-md { gap: ${SPACING.md} !important; }
    .mobile-gap-lg { gap: ${SPACING.lg} !important; }
  }
`;

// デフォルトエクスポート用オブジェクト（ESLint警告修正）
const styleConstants = {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  SPACING,
  BORDER_RADIUS,
  SHADOWS,
  Z_INDEX,
  TRANSITIONS,
  BREAKPOINTS,
  MEDIA_QUERIES,
  LAYOUT,
  COMPONENTS,
  MOBILE_STYLES,
};

export default styleConstants;